module.exports = __webpack_public_path__ + "img/LINKEDIN_ICON.cfa430fc.svg";